import type { InjectionKey, Ref } from 'vue';
import { inject, provide, ref } from 'vue';

export type FasletPdpAddToCartHandler = (variantId: string) => void | Promise<void>;

/**
 * Faslet `withAddToCart` must call into `ShopwareProductDetailAddToCart`, which uses top-level `await`
 * (async setup). A parent `ref` + `defineExpose` is unreliable; a module-level singleton breaks under
 * concurrent Nuxt SSR. This injection is scoped to `ShopwareProductDetailMain` (one ref per PDP).
 */
export const fasletPdpAddToCartHandlerKey: InjectionKey<Ref<FasletPdpAddToCartHandler | null>> =
    Symbol('fasletPdpAddToCartHandler');

export function provideFasletPdpAddToCartHandler(): Ref<FasletPdpAddToCartHandler | null> {
    const target = ref<FasletPdpAddToCartHandler | null>(null);
    provide(fasletPdpAddToCartHandlerKey, target);
    return target;
}

export function useFasletPdpAddToCartHandler(): Ref<FasletPdpAddToCartHandler | null> | null {
    return inject(fasletPdpAddToCartHandlerKey, null);
}
